module.exports = __webpack_public_path__ + "static/media/Warning.f36e406f.svg";